import { pushService } from './api';
import { urlBase64ToUint8Array } from '../utils/webPush';

/** Чи підтримує браузер Web Push + Service Worker. */
export function isWebPushSupported() {
  return typeof window !== 'undefined'
    && 'serviceWorker' in navigator
    && 'PushManager' in window
    && typeof Notification !== 'undefined';
}

/** Чи відкрито як встановлений PWA (standalone). */
export function isRunningAsPwa() {
  if (typeof window === 'undefined') return false;
  if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) return true;
  // iOS Safari
  return Boolean(window.navigator.standalone);
}

/**
 * Підписка на Web Push для поточного користувача (будь-який staff після логіну).
 * @param {*} _currentUser
 * @param {{ requestPermission?: boolean }} [opts] — якщо false, не показує системний діалог (лише якщо вже granted).
 * @returns {{ ok: boolean, reason?: string }}
 */
export async function tryEnableWebPush(_currentUser, opts = {}) {
  const requestPermission = opts.requestPermission !== false;
  if (!isWebPushSupported()) {
    return { ok: false, reason: 'unsupported' };
  }

  const keyRes = await pushService.getVapidPublicKey();
  const publicKey = (keyRes.data && keyRes.data.publicKey) || '';
  if (!publicKey) {
    return { ok: false, reason: 'no_vapid' };
  }

  const registration = await navigator.serviceWorker.register('/sw.js');

  let perm = Notification.permission;
  if (perm === 'default') {
    if (!requestPermission) {
      return { ok: false, reason: 'needs_permission' };
    }
    perm = await Notification.requestPermission();
  }
  if (perm !== 'granted') {
    return { ok: false, reason: 'denied' };
  }

  const applicationServerKey = urlBase64ToUint8Array(publicKey);
  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey,
    });
  }

  const subJson = subscription.toJSON();
  await pushService.subscribe({
    subscription: {
      endpoint: subJson.endpoint,
      keys: subJson.keys,
    },
  });

  return { ok: true };
}

/** @deprecated alias — раніше лише для закупівель */
export async function trySubscribePurchaseRequestPush(currentUser) {
  return tryEnableWebPush(currentUser);
}

/** Статус підписки / дозволу для UI. */
export async function getWebPushStatus() {
  if (!isWebPushSupported()) {
    return { supported: false, permission: 'unsupported', subscribed: false };
  }
  const permission = Notification.permission;
  let subscribed = false;
  try {
    const reg = await navigator.serviceWorker.getRegistration('/sw.js')
      || await navigator.serviceWorker.getRegistration();
    if (reg) {
      const sub = await reg.pushManager.getSubscription();
      subscribed = Boolean(sub);
    }
  } catch (_) {
    /* ignore */
  }
  return { supported: true, permission, subscribed };
}

/** Видалити підписку на сервері (наприклад, перед виходом). */
export async function unsubscribeWebPush() {
  if (!isWebPushSupported()) return;
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return;
    const ep = sub.endpoint;
    try {
      await pushService.unsubscribe({ endpoint: ep });
    } catch (_) {
      /* ignore */
    }
    await sub.unsubscribe().catch(() => {});
  } catch (_) {
    /* ignore */
  }
}

/** @deprecated alias */
export async function unsubscribePurchaseRequestPush() {
  return unsubscribeWebPush();
}
